/*
 * @Author: Dzy
 * @Date: 2022-07-18 11:13:54
 * @LastEditors: Dzy
 * @LastEditTime: 2022-10-18 09:43:45
 * @Description: 验证码模块
 */
import { getCaptcha } from '@/api/auth.js'
import { message } from 'ant-design-vue'
import { useRequest } from 'vue-request'
import { ref } from 'vue'

const emptyData = {
  imgUrl: '',
  randomStr: ''
}
export default () => {
  const { data: result, runAsync, loading: captchaLoading } = useRequest(getCaptcha)
  const captcha = ref(emptyData)
  const loadCaptcha = async () => {
    await runAsync()
    if (result.value.randomStr) {
      Object.keys(result.value).forEach((key) => (captcha.value[key] = result.value[key]))
    } else {
      message.warn('获取校验码失败，请稍后再试！')
      captcha.value = { ...emptyData }
    }
  }

  return {
    captcha,
    captchaLoading,
    loadCaptcha
  }
}
